// screens/create-product-mgt/AllocateMenuPrice.jsx
import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Button, Table, Card, Alert, Spinner, InputGroup, Badge } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from '../../api/axios';

const AllocateMenuPrice = ({ data, onNext, onBack, updateData, currentStep, isSubmitting }) => {
    const [groups, setGroups] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [prices, setPrices] = useState({
        mrpPrice: '',
        offerPrice: ''
    });
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [existingPricingData, setExistingPricingData] = useState([]);

    const accessToken = localStorage.getItem('authToken');
    const [pricingId, setPricingId] = useState('');
    const productData = data.product || {};
    const productId = productData._id;

    const getMenuGroup = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axios.get("menu-group", { headers });

            if (response?.data?.status === true) {
                setGroups(response?.data?.data?.menuGroup || []);
                fetchExistingPricing(response?.data?.data?.menuGroup || []);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    useEffect(() => {
        getMenuGroup();
        // fetchExistingPricing();
    }, []);

    // useEffect(() => {
    //     // When groups load AND existing pricing is fetched, merge them
    //     if (groups?.length > 0 && existingPricingData?.length > 0) {

    //         const allGroups = groups.map(group => {
    //             // Find existing pricing for this group
    //             console.log("Group in USeEffect:", group);
    //             console.log("existingPricingData :", existingPricingData);


    //             const existingPrice = existingPricingData.find(
    //                 pricing => pricing.group === group._id
    //             );

    //             console.log("Existing Price :", existingPrice);
    //             setPricingId(existingPrice?._id);
    //             return {
    //                 ...group,
    //                 pricingId: existingPrice?._id,
    //                 groupId: group._id,
    //                 groupName: group.groupName,
    //                 mrpPrice: existingPrice?.mrpPrice || productData.mrp || '',
    //                 offerPrice: existingPrice?.offerPrice || productData.offerPrice || '',
    //                 isSelected: existingPrice ? true : true // Select if already has pricing
    //             };
    //         });
    //         setSelectedGroups(allGroups);
    //     }
    // }, [groups, existingPricingData, productData]);

    // const getFilteredPrices = (data) => {
    //     if (groups?.length > 0 && data?.length > 0) {

    //         const allGroups = groups?.map(group => {
    //             // Find existing pricing for this group
    //             console.log("Group in USeEffect : ", group);
    //             console.log("existingPricingData :", data);


    //             // const existingPrice = data.find(
    //             //     pricing => pricing?.group?._id === group._id
    //             // );

    //             const existingPrice = data?.find((pricing) => 
    //                 pricing?.group?._id === group?._id
    //             );


    //             console.log("Existing Price :", existingPrice);
    //             setPricingId(existingPrice?._id);
    //             return {
    //                 ...group,
    //                 pricingId: existingPrice?._id,
    //                 groupId: group._id,
    //                 groupName: group.groupName,
    //                 mrpPrice: existingPrice?.mrpPrice || productData.mrp || '',
    //                 offerPrice: existingPrice?.offerPrice || productData.offerPrice || '',
    //                 isSelected: existingPrice ? true : true // Select if already has pricing
    //             };
    //         });
    //         setSelectedGroups(allGroups);
    //     }
    // }

    const getFilteredPrices = (data, groupList) => {
        console.log("List of groups :", groups);
        console.log("groupList groupList :", groupList);
        
        console.log("Data Cming therough api :", data);
        
        if (!groupList?.length || !data?.length) return;

        console.log("🚀 getFilteredPrices called");
        console.log("Groups:", groups);
        console.log("Pricing Data Count:", data.length);

        const allGroups = groupList.map((group) => {
            console.log("──────────────────────────────");
            console.log("👉 Processing Group:", {
                groupId: group?._id,
                groupName: group?.groupName,
                isDefaultGroup: group?.isDefaultGroup
            });

            // 1️⃣ Try exact group match
            let existingPrice = data.find(
                (pricing) => pricing?.group?._id === group?._id && pricing?.product?._id === productId
            );

            console.log("Exact Match Price:", existingPrice);
            setPricingId(existingPrice?._id);
            // 2️⃣ Fallback to default group pricing
            if (!existingPrice) {
                existingPrice = data.find(
                    (pricing) => pricing?.group?.isDefaultGroup === true
                );
                console.log("🔁 Default Group Price Used:", existingPrice);
            }

            // 3️⃣ If still not found
            if (!existingPrice) {
                console.log("❌ No pricing found for group:", group?.groupName);
            }

            return {
                ...group,
                pricingId: existingPrice?._id || null,
                groupId: group?._id,
                groupName: group?.groupName,
                mrpPrice: existingPrice?.mrpPrice ?? productData?.mrp ?? '',
                offerPrice: existingPrice?.offerPrice ?? productData?.offerPrice ?? '',
                isSelected: !!existingPrice
            };
        });

        console.log("✅ Final Selected Groups:", allGroups);

        setSelectedGroups(allGroups);
    };
    
    const fetchExistingPricing = async (groupL) => {
        setIsLoading(true);

        console.log("Gelllo :");

        if (!productData._id) return;
        console.log("Gelllo 1:");

        console.log("Gelllo 1 Group :", groupL);


        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            // Fetch existing pricing for this product
            const response = await axios.get(`menu-product-pricing?product=${productData._id}`, { headers });
            console.log("Response of gett Api :", response);

            if (response?.data?.status === true) {
                setExistingPricingData(response.data.data.menuGroup || []);
                getFilteredPrices(response.data.data.menuGroup || [], groupL)
            }
        } catch (error) {
            console.log("Error fetching existing pricing:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handlePriceChange = (field, value) => {
        setPrices(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleGroupSelection = (groupId, isSelected) => {
        setSelectedGroups(prev =>
            prev.map(group =>
                group._id === groupId
                    ? { ...group, isSelected }
                    : group
            )
        );
    };

    const handleGroupPriceChange = (groupId, field, value) => {
        setSelectedGroups(prev =>
            prev.map(group =>
                group._id === groupId
                    ? { ...group, [field]: value }
                    : group
            )
        );
    };

    const applyUniformPrice = () => {
        if (!prices.mrpPrice || !prices.offerPrice) {
            toast.error('Please enter both MRP and Offer Price', { position: 'top-right' });
            return;
        }

        const updatedGroups = selectedGroups.map(group => ({
            ...group,
            mrpPrice: group.isSelected ? prices.mrpPrice : group.mrpPrice,
            offerPrice: group.isSelected ? prices.offerPrice : group.offerPrice
        }));

        setSelectedGroups(updatedGroups);
        toast.success(`Applied prices to selected groups`, { position: 'top-right' });
    };

    const applyToAll = () => {
        if (!prices.mrpPrice || !prices.offerPrice) {
            toast.error('Please enter both MRP and Offer Price', { position: 'top-right' });
            return;
        }

        const updatedGroups = selectedGroups.map(group => ({
            ...group,
            mrpPrice: prices.mrpPrice,
            offerPrice: prices.offerPrice,
            isSelected: true
        }));

        setSelectedGroups(updatedGroups);
        toast.success(`Applied prices to all groups`, { position: 'top-right' });
    };

    const toggleAllSelection = (isSelected) => {
        const updatedGroups = selectedGroups.map(group => ({
            ...group,
            isSelected
        }));
        setSelectedGroups(updatedGroups);
    };

    const handleNextStep = async () => {
        // Validate that we have a product ID from previous step
        if (!productData._id) {
            toast.error('Product not created yet. Please go back to Step 1.', { position: 'top-right' });
            return;
        }
        console.log("Selected Groups in handle Next Step:", selectedGroups);

        // Filter selected groups
        const selected = selectedGroups?.filter(group => group.isSelected);

        console.log("Selected in handle Next Step:", selected);

        if (selected.length === 0) {
            toast.error('Please select at least one menu group', { position: 'top-right' });
            return;
        }

        // Validate prices for selected groups
        const invalidGroups = selected.filter(group =>
            !group.mrpPrice || group.mrpPrice <= 0 || !group.offerPrice || group.offerPrice <= 0
        );

        if (invalidGroups.length > 0) {
            toast.error('Please enter valid prices for all selected groups', { position: 'top-right' });
            return;
        }

        // Prepare payload for UPDATE API (PUT) only
        const payload = selected?.map(group => ({
            _id: group?.pricingId, // Always include _id for update (if exists)
            group: group._id,
            product: productData._id,
            mrpPrice: parseFloat(group.mrpPrice),
            offerPrice: parseFloat(group.offerPrice)
        })
        );

        console.log("Payload for UPDATE:", payload);

        // ).filter(item => item._id); // Only include items with _id for UPDATE

        // Check if we have any groups with existing pricing IDs
        const hasExistingPricing = payload.length > 0;

        // if (!hasExistingPricing) {
        //     // If no existing pricing, show error (since we're only doing updates)
        //     toast.error('No existing pricing found to update. Please create pricing first.', { position: 'top-right' });
        //     return;
        // }

        setIsSaving(true);
        try {
            const headers = {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
            };

            // Use PUT for UPDATE only
            console.log("Updating pricing with payload:", payload);
            const response = await axios.put('menu-product-pricing/addMultileProductsWithOutFile', payload, { headers });

            if (response?.status === 200 || response?.data?.status === true) {
                const responseData = response.data.data || response.data;

                toast.success('Prices updated successfully!', { position: 'top-right' });

                // Store pricing data for next steps
                updateData('pricing', {
                    menuGroups: selected,
                    payload: payload,
                    totalGroups: selected?.length,
                    isAllocated: true,
                    existingPricing: responseData
                });

                // Proceed to next step AFTER successful API call
                onNext();
            } else {
                toast.error(response?.data?.error || 'Failed to update prices', { position: 'top-right' });
            }
        } catch (error) {
            console.error('Error updating prices:', error);

            let errorMessage = 'Failed to update prices';
            if (error.response) {
                if (error.response.status === 406) {
                    errorMessage = error.response.data.error?.message || error.response.data.error;
                } else if (error.response.status === 404) {
                    errorMessage = error.response.data.data?.message;
                } else if (error.response.status === 412) {
                    errorMessage = error.response.data.data?.message;
                } else if (error.response.status === 400) {
                    errorMessage = error.response.data.error;
                } else if (error.response.status === 500) {
                    errorMessage = error.response.data.message || error.response.data.error;
                }
            }

            toast.error(errorMessage, { position: "top-right", autoClose: 3000, theme: "colored" });
        } finally {
            setIsSaving(false);
        }
    };

    const selectedCount = selectedGroups.filter(g => g.isSelected).length;
    const totalGroups = groups.length;
    const hasExistingPricing = selectedGroups.some(g => g.pricingId);

    return (
        <div className="allocate-menu-price-step">
            <h6 className="mb-4 text-primary">Step 2: Allocate Menu Group Pricing</h6>

            {!productData._id && (
                <Alert variant="warning" className="mb-4">
                    <Alert.Heading>Product Not Created Yet</Alert.Heading>
                    <p>Please go back to Step 1 and create the product first to get the Product ID.</p>
                </Alert>
            )}

            {/* {hasExistingPricing ? (
                <Alert variant="info" className="mb-4">
                    <Alert.Heading>Update Existing Pricing</Alert.Heading>
                    <p>This product already has pricing allocated. You can modify prices below and click "Next" to update.</p>
                </Alert>
            ) : (
                <Alert variant="warning" className="mb-4">
                    <Alert.Heading>No Existing Pricing Found</Alert.Heading>
                    <p>This product doesn't have any pricing allocated yet. Please allocate pricing through another interface first.</p>
                </Alert>
            )} */}

            {/* Uniform Price Application Card */}
            <Card className="mb-4">
                <Card.Body>
                    <h6 className="mb-3">Quick Price Update</h6>
                    <Row className="gy-3">
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Uniform MRP (₹)</Form.Label>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={prices.mrpPrice}
                                    onChange={(e) => handlePriceChange('mrpPrice', e.target.value)}
                                    placeholder={productData.mrp || "Enter MRP"}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label>Uniform Offer Price (₹)</Form.Label>
                                <Form.Control
                                    type="number"
                                    step="0.01"
                                    value={prices.offerPrice}
                                    onChange={(e) => handlePriceChange('offerPrice', e.target.value)}
                                    placeholder={productData.offerPrice || "Enter Offer Price"}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Label>&nbsp;</Form.Label>
                            <div className="d-flex gap-2">
                                <Button
                                    variant="primary"
                                    onClick={applyUniformPrice}
                                    disabled={!prices.mrpPrice || !prices.offerPrice}
                                >
                                    Apply to Selected
                                </Button>
                                <Button
                                    variant="outline-primary"
                                    onClick={applyToAll}
                                    disabled={!prices.mrpPrice || !prices.offerPrice}
                                >
                                    Apply to All
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Card>
                <Card.Body>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div>
                            <h6 className="mb-0">Menu Groups Pricing</h6>
                            <small className="text-muted">
                                {selectedCount} of {totalGroups} groups selected
                                {hasExistingPricing && (
                                    <Badge bg="info" className="ms-2">
                                        {selectedGroups.filter(g => g.pricingId).length} have pricing
                                    </Badge>
                                )}
                            </small>
                        </div>
                        <div className="d-flex gap-2">
                            <Form.Check
                                type="switch"
                                id="select-all-switch"
                                label="Select All"
                                checked={selectedCount === totalGroups && totalGroups > 0}
                                onChange={(e) => toggleAllSelection(e.target.checked)}
                            />
                        </div>
                    </div>

                    {isLoading ? (
                        <div className="text-center py-5">
                            <Spinner animation="border" variant="primary" />
                            <p className="mt-2">Loading menu groups...</p>
                        </div>
                    ) : (
                        <div className="table-responsive">
                            <Table striped hover>
                                <thead>
                                    <tr>
                                        <th width="50">
                                            <Form.Check
                                                type="checkbox"
                                                checked={selectedCount === totalGroups && totalGroups > 0}
                                                onChange={(e) => toggleAllSelection(e.target.checked)}
                                            />
                                        </th>
                                        <th>Menu Group</th>
                                        <th>MRP (₹)</th>
                                        <th>Offer Price (₹)</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedGroups.map((group) => (
                                        <tr key={group._id}>
                                            <td>
                                                <Form.Check
                                                    type="checkbox"
                                                    checked={group.isSelected || false}
                                                    onChange={(e) => handleGroupSelection(group._id, e.target.checked)}
                                                />
                                            </td>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    <strong className='text-secondary'>{group.groupName}</strong>
                                                </div>
                                                {group.description && (
                                                    <div className="text-muted small">{group.description}</div>
                                                )}
                                            </td>
                                            <td>
                                                <Form.Control
                                                    type="number"
                                                    step="0.01"
                                                    value={group.mrpPrice || ''}
                                                    onChange={(e) => handleGroupPriceChange(group._id, 'mrpPrice', e.target.value)}
                                                    disabled={!group.isSelected}
                                                    style={{ width: '120px' }}
                                                    placeholder={productData.mrp || "MRP"}
                                                />
                                            </td>
                                            <td>
                                                <Form.Control
                                                    type="number"
                                                    step="0.01"
                                                    value={group.offerPrice || ''}
                                                    onChange={(e) => handleGroupPriceChange(group._id, 'offerPrice', e.target.value)}
                                                    disabled={!group.isSelected}
                                                    style={{ width: '120px' }}
                                                    placeholder={productData.offerPrice || "Offer"}
                                                />
                                            </td>
                                            <td>
                                                {group.pricingId ? (
                                                    <Badge bg="success">
                                                        Has Pricing
                                                    </Badge>
                                                ) : (
                                                    <Badge bg="secondary">
                                                        No Pricing
                                                    </Badge>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                    )}

                    <Alert variant="info" className="mt-3">
                        <Alert.Heading>Instructions:</Alert.Heading>
                        <ul className="mb-0">
                            <li>Select menu groups you want to update</li>
                            <li>Modify MRP and Offer Price for selected groups</li>
                            <li>Use "Apply to Selected" or "Apply to All" for quick updates</li>
                            <li>Only groups with existing pricing (marked with green badge) can be updated</li>
                            <li>Click "Next: Allocate Add-ons →" to UPDATE prices and proceed</li>
                        </ul>
                    </Alert>
                </Card.Body>
            </Card>

            <div className="mt-4 d-flex justify-content-between">
                <Button
                    variant="outline-secondary"
                    onClick={onBack}
                    disabled={isSaving || isSubmitting}
                >
                    ← Back to Product Details
                </Button>
                <Button
                    variant="primary"
                    onClick={handleNextStep}
                    disabled={isSaving || isSubmitting || !productData._id}
                >
                    {isSaving ? (
                        <>
                            <Spinner size="sm" animation="border" className="me-2" />
                            Updating Prices...
                        </>
                    ) : (
                        'Next: Allocate Add-ons →'
                    )}
                </Button>
            </div>
        </div>
    );
};

export default AllocateMenuPrice;